import React, { Suspense, lazy, useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "./app/hooks";
import { loadFromStorage } from "./app/features/authSlice";
import { getCustomDomainHost } from "./lib/tenant";
import { Toaster } from "react-hot-toast";
import DialogProvider from "./components/common/DialogProvider";

// Code-split: visitors to a subscriber's website only download the tenant
// bundle, not the whole dashboard/admin app (and vice versa).
const AppRoutes = lazy(() => import("./routes"));
const TenantApp = lazy(() => import("./pages/tenant/TenantApp"));

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const hydrated = useAppSelector((state) => state.auth.hydrated);

  // Whitelabel custom domains take over the whole origin and render that
  // subscriber's site. Platform subscribers are served at
  // launchkitnaija.com/s/<handle> via the normal routes below.
  const customHost = getCustomDomainHost();

  // Hydrate auth synchronously on app mount
  useEffect(() => {
    dispatch(loadFromStorage());
  }, [dispatch]);

  // Prevent routes/layouts from rendering before auth is ready
  if (!hydrated) {
    return null;
  }

  return (
    <BrowserRouter>
      <DialogProvider>
        <Toaster position="top-right" />
        <Suspense fallback={null}>
          {customHost ? <TenantApp host={customHost} /> : <AppRoutes />}
        </Suspense>
      </DialogProvider>
    </BrowserRouter>
  );
};

export default App;
